export { default as YotpoReviewStars } from './YotpoReviewStars';
